import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ShActionGroupComponent } from '../action-group/action-group.component';
import { ActionGroup } from '../action-group/entities/action-group.entity';
@Component({
    standalone: true,
    selector: 'sh-action-bar',
    templateUrl: './action-bar.component.html',
    styleUrls: ['./action-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ShActionGroupComponent]
})
export class ShActionBarComponent {
    @Input() actionGroup!: ActionGroup;
}
